<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 19.0225V23.4H9V39.9952C9 41.0998 9.89543 41.9952 11 41.9952H26.2V27.9C26.2 25.1386 28.4386 22.9 31.2 22.9H41.9C41.9334 22.9 41.9667 22.9003 42 22.901V18.9443L24.144 4L6 19.0225ZM14.7 25.9H19.7V30.9H14.7V25.9ZM43.9 27.9C43.9 26.7954 43.0046 25.9 41.9 25.9H31.2C30.0954 25.9 29.2 26.7954 29.2 27.9V43.9L31.65 42.8781L34.1 43.9L36.55 42.8781L39 43.9L41.45 42.8781L43.9 43.9V27.9ZM40.7 29.9H32V31.9H40.7V29.9ZM32 34.5H37.1V36.5H32V34.5Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
